{
  "reactions": {
    "react": "React",
    "like": "Like",
    "fire": "Fire",
    "clap": "Clap",
    "trophy": "Trophy",
    "muscle": "Muscle",
    "failed_to_add": "Failed to add reaction",
    "who_reacted": "Reactions",
    "no_reactions": "No reactions yet",
    "total": "{{count}} Reactions",
    "all": "All"
  },
  "comments": {
    "title": "Comments",
    "write_comment": "Write a comment...",
    "write_reply": "Write a reply...",
    "post_comment": "Post Comment",
    "reply": "Reply",
    "replies": "replies",
    "no_comments": "No comments yet. Be the first to comment!",
    "comment_posted": "Comment posted successfully",
    "reply_posted": "Reply posted successfully",
    "failed_to_post": "Failed to post comment",
    "comment_deleted": "Comment deleted",
    "failed_to_delete": "Failed to delete comment",
    "confirm_delete": "Are you sure you want to delete this comment?",
    "confirm_delete_header": "Delete Comment"
  }
}
